import React from 'react';
import { useForm } from 'react-final-form';
import Popup from '../ui/Popup';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import MandatorySymbol from '../ui/MandatorySymbol';
import { FormState, getIn } from 'final-form';

interface PopupErrorFormProps {
  errorMessage: MessageDescriptor;
  onClose?: () => void;
  formState?: FormState<any>;
}

const PopupErrorForm: React.FC<PopupErrorFormProps> = ({ errorMessage, formState, onClose }) => {
  const form = useForm();

  const errors = formState?.errors ?? {};

  const count = form.getRegisteredFields().reduce((acc, registerField)=>{
    const errorFind = getIn(errors, registerField);
    if (typeof errorFind ==='string') {
      return ++acc;
    }
    return acc;
  }, 0);

  return (
    <Popup
      onClose={onClose}
      title={(
        <FormattedMessage
          tagName="h2"
          values={{
            count,
            mandatory: <MandatorySymbol className="!mr-0" />
          }}
          {...errorMessage}
        />
      )}
    />
  );
};


export default PopupErrorForm;